import useHeldValue from 'hooks/useHeldValue'
import { nonNullable, take } from 'lib/array/arrayUtils'
import { useMemo } from 'react'
import { MapLayerGroup } from 'tripPlanner/contexts/MapLayers/MapLayersContext'
import { PublicFullTrip, PublicTripItem } from 'tripPlanner/types/publicTrip'
import { TripItem } from 'tripPlanner/types/tripItem'
import { mapLEOfferToMarker } from '../utils'
import { FullTrip } from 'tripPlanner/types/common'
import useOfferList from 'hooks/Offers/useOfferList'
import useOffers from 'hooks/Offers/useOffers'
import config from 'constants/config'
import { HOTEL_SEARCH_TYPES, OFFER_TYPE_VILLA } from 'constants/offer'
import { extractSelectedItemId } from 'tripPlanner/utils/itemSelection'

const offerTypes: Array<App.OfferListOfferType> = [...HOTEL_SEARCH_TYPES]
if (config.ENABLE_VILLA_RENTALS) {
  offerTypes.push(OFFER_TYPE_VILLA)
}

export default function useLEHotelPins(
  trip: FullTrip | PublicFullTrip,
  layerGroups: Array<MapLayerGroup>,
  bounds: string | undefined,
  currentSelectionId: string | undefined,
) {
  const hotelsLayerEnabled = !!layerGroups.find(group => group.id === 'leProducts')?.layers.find(layer => layer.id === 'hotels')?.isSelected
  const shouldUseHotels = hotelsLayerEnabled && !!bounds

  const selectedHotelId = extractSelectedItemId(currentSelectionId, 'hotel')

  const offerList = useOfferList({ offerTypes, bounds }, { disabled: !shouldUseHotels })

  const offerIds = [
    ...(shouldUseHotels ? take(offerList.offerIds, 30) : []),
    ...(selectedHotelId && !offerList.offerIds.includes(selectedHotelId) ? [selectedHotelId] : []),
  ]

  const [_offers] = useOffers<App.HotelOffer>(offerIds)
  const offers = useHeldValue(_offers, hotelsLayerEnabled && _offers.length === 0)

  const hotelMarkers = useMemo(() => {
    const savedOfferIds = new Set(nonNullable(trip.items.map((item: TripItem | PublicTripItem) => 'code' in item ? item.code : undefined)))
    return offers
      .filter(offer => !savedOfferIds.has(offer.id))
      .map(mapLEOfferToMarker)
  }, [offers, trip.items])

  return hotelMarkers
}
